import Bugsnag from '@bugsnag/js';
import { dehydrate } from '@tanstack/react-query';
import type { GetServerSideProps } from 'next';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

import { DonationSide } from '@/core/components/DonationDetails/DonationSide';
import { BannerSlot } from '@/core/lib/ads/ads.context';
import Query from '@/core/lib/new-architecture/query';
import makeQueryClient from '@/core/lib/query/queryClient';
import base from '@/core/lib/translation/base';
import DonationDetailPage from '@/core/pages/donation/DonationDetail';
import DetailsLayout from '@/next/layouts/DetailsLayout';
import ShareProvider from '@/next/lib/share/ShareProvider.next';

export const getServerSideProps: GetServerSideProps = async context => {
  try {
    const { id } = context.query;

    if (isNaN(Number(id))) {
      return {
        redirect: {
          permanent: true,
          destination: '/catalogue',
        },
      };
    }
    const queryClient = makeQueryClient();

    await Promise.all([await Query.categories.useCategories.prefetch?.({ queryClient }), await Query.donation.useDonation.prefetch?.({ id: Number(id) as number, isLoggedIn: false, queryClient })]);

    const dehydratedState = dehydrate(queryClient);

    return {
      props: {
        ...(await serverSideTranslations('fr', [...base, 'donation-detail', 'profile.donations'])),
        path: `/don/${context.query.id}`,
        dehydratedState,
      },
    };
  } catch (err) {
    Bugsnag.notify(err as Error);

    return {
      props: {
        ...(await serverSideTranslations('fr', [...base, 'donation-detail', 'profile.donations'])),
        path: `/don/${context.query.id}`,
      },
    };
  }
};

DonationDetailPage.getProviders = page => {
  return <ShareProvider>{page}</ShareProvider>;
};

// TODO: gérer le changement de layout Public/Private si user connecté ou pas
DonationDetailPage.getLayouts = page => {
  const adUnit = '/22963265510,23187251655/23187251655/od.donnons.org/annonce';
  const dataConfig = {
    adUnit,
  };
  return (
    <DetailsLayout adSlot={BannerSlot.DONNONS_LIST_SIDE} sideComponent={<DonationSide />}>
      <Head>
        <script dangerouslySetInnerHTML={{ __html: 'var optidigitalQueue = optidigitalQueue || {}; optidigitalQueue.cmd = optidigitalQueue.cmd || [];' }}></script>
        <link rel="preload" href="https://securepubads.g.doubleclick.net/tag/js/gpt.js" as="script" type="text/javascript" />
        <script type="module" id="optidigital-ad-init" async src="//scripts.opti-digital.com/modules/?site=donnons" data-config={JSON.stringify(dataConfig)} />
      </Head>
      {page}
    </DetailsLayout>
  );
};

DonationDetailPage.footer = { catalogue: true };

export default DonationDetailPage;
